import {
  Direction,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { getApplicationDirection } from '@nice-ccf/ui-components';
import {
  CcfAppHealthIcon,
  CcfBox,
  CcfHeader,
  CcfTypography,
  useTranslator,
  CcfSlider,
  CcfButton,
} from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import styles from './ccf-app-health.module.scss';
import {
  getLoggedInUser,
  selectLoginCredentialsState,
} from '../../login/+state/login.slice';
import { useState } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

/* eslint-disable-next-line */
export interface CcfAppHealthProps {}

/**
 * used to show App Health(Network status) static screen
 * @param props - CcfAppHealthProps
 * @example ` <CcfAppHealth inboxCardState={inboxCardState} />`
 */
export function CcfAppHealth(props: CcfAppHealthProps) {
  const appDirection: Direction = useSelector(getApplicationDirection);
  const [translate] = useTranslator();
  const userData = useSelector(getLoggedInUser);
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const loginCredentials = useSelector(selectLoginCredentialsState);
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const agentName = isAuthenticated
    ? loginCredentialsArray[0].charAt(0).toUpperCase() +
      loginCredentialsArray[0].slice(1).toLowerCase() +
      ' ' +
      loginCredentialsArray[1].charAt(0).toUpperCase() +
      loginCredentialsArray[1].slice(1).toLowerCase()
    : loginCredentials.firstName.charAt(0).toUpperCase() +
      loginCredentials.firstName.slice(1).toLowerCase() +
      ' ' +
      loginCredentials.lastName.charAt(0).toUpperCase() +
      loginCredentials.lastName.slice(1).toLowerCase();

  const [logLevel, setLogLevel] = useState(2);

  const handleChange = (event: any) => {
    setLogLevel(event.target.value);
  };
  return (
    // <div className={className.get(props.inboxCardState)}>
    //   <img className={styles.fitImage} src="./../assets/Network_Status_Static_Image.png" alt="App Health" />
    // </div>

    <section className={styles.networkHealthContainer}>
      {/* <CcfBox component="div" className={styles.networkHealthHeader}>
        <CcfHeader
            LeftIcon={
              <CcfAppHealthIcon className={styles.networkStatusIcon} />
            }
            headerText={translate('networkStatus')}
            RightIcon
            showDragIcon
            direction={appDirection}
        /> 
      </CcfBox> */}

      <CcfBox
        component="div"
        ml={2.5}
        // height={'20%'}
        display="flex"
        flexDirection={'column'}
        className={styles.networkHeaderSlider}
      >
        <CcfBox component="div" className={styles.networkHeader}>
          <CcfBox
            component="div"
            display="flex"
            flexDirection={'column'}
            justifyContent={'space-evenly'}
            height={'100%'}
          >
            <CcfTypography className={styles.networkStatusTitle}>
              {translate('networkstatus')}
            </CcfTypography>
            <CcfTypography className={styles.networkStatusSubTitle}>
              {new Date().toLocaleString('en-US', {
              weekday: 'short',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              timeZone: 'Asia/Kolkata',
              timeZoneName: 'short',
              }).replace(/,/g, '').replace(' at ', ' ')}{' '}
              (India Standard Time)
            </CcfTypography>
          </CcfBox>
          {/* <CcfButton primary className={styles.reloadAppBtn}>
            {translate('reloadApplication')}
          </CcfButton> */}
        </CcfBox>
        <CcfBox
          component="div"
          className={styles.sliderContainer}
          display="flex"
        >
          <CcfTypography className={styles.sliderMinValue}>0(s)</CcfTypography>
          <CcfSlider />
          <CcfTypography className={styles.sliderMaxValue}>4.00</CcfTypography>
        </CcfBox>
      </CcfBox>
      <div
        style={{
          width: '109%',
          borderWidth: '0px 0px thin',
          borderStyle: 'solid',
          borderColor: 'rgb(227, 233, 238)',
          marginBottom: '0.5rem'
        }}
      />

      <CcfBox component="div" className={styles.networkContent}>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('agentName')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{agentName}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('displayedUsername')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {isAuthenticated
                ? accounts[0]?.username
                : loginCredentials?.email}
            </CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('agentId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {userData.agentID}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('version')} 25.1.3.5-Agent
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'5913364b53'}
            </CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('stationId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'N/A'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('sessionId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'436651778'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('phoneNumber')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'WebRTC'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('agentLegId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'N/A'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('callerId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'4005554444'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('browserVersion')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'Chrome 83'}
            </CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('webServer')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'—'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('virtualCluster')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'SOB-C32COR01'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('browserLanguage')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'en-US'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('browserLocalization')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'en-US'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('teamName')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {userData?.team}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
      </CcfBox>
      <div
        style={{
          width: '109%',
          borderWidth: '0px 0px thin',
          borderStyle: 'solid',
          borderColor: 'rgb(227, 233, 238)',
        }}
      />
      <CcfBox component="div" className={styles.networkContent}>
        
      <CcfBox className={styles.networkContentBlock}>
        <CcfBox
          component="div"
          className={styles.titleValueContainer}
          style={{ width: '100%', height: '40px', paddingBottom: '0.5rem',}}
        >
          <CcfTypography
            className={styles.title}
            style={{
              textTransform: 'capitalize',
              fontSize: '16px',
            }}
          >
            {translate('interactionRouting')}
          </CcfTypography>
{/* 
          <CcfTypography className={styles.value}>
            {userData.firstName} {userData.lastName}
          </CcfTypography> */}
        </CcfBox>
      </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('contactLimit')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'1 call, 2 emails, 4 chats'}
            </CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('totalLimit')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'16'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('routing')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'Omni'}</CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('reqContact')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'Enabled'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('contactAutoFocus')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'Enabled'}</CcfTypography>
          </CcfBox>
        </CcfBox>
      </CcfBox>
      <div
        style={{
          width: '109%',
          borderWidth: '0px 0px thin',
          borderStyle: 'solid',
          borderColor: 'rgb(227, 233, 238)',
          marginBottom: '0.5rem'
        }}
      />
      <CcfBox component="div" className={styles.networkContent}>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography
              className={styles.title}
              style={{
                textTransform: 'capitalize',
                fontSize: '16px',
                paddingTop: '4rem',
              }}
            >
              Logging Configuration
            </CcfTypography>

            <FormControl fullWidth variant="outlined" sx={{ marginTop: '16px', width: '200px' }}>
              <TextField
              select
              label="Log Level"
              id="log-level-select"
              value={logLevel}
              onChange={handleChange}
              variant="outlined"
              >
              <MenuItem value={0}>Trace</MenuItem>
              <MenuItem value={1}>Debug</MenuItem>
              <MenuItem value={2}>Info</MenuItem>
              <MenuItem value={3}>Warn</MenuItem>
              <MenuItem value={4}>Error</MenuItem>
              <MenuItem value={5}>Fatal</MenuItem>
              <MenuItem value={6}>Off</MenuItem>
              </TextField>
            </FormControl>
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </section>
  );
}
